var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0772 6.11765H8.92338V3.76471C8.92338 2.79996 9.76026 2 10.7695 2H13.2311C14.2403 2 15.0772 2.77647 15.0772 3.76471V6.11765ZM12 5C12.5522 5 13 4.55218 13 4C13 3.44782 12.5522 3 12 3C11.4478 3 11 3.44782 11 4C11 4.55218 11.4478 5 12 5Z",
    fill: "#A614B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1539 22H5.84616C4.83688 22 4 21.2235 4 20.2353V6.11765C4 5.1529 4.83688 4.37643 5.84616 4.35294H8.30771V5.52941H5.84616C5.50155 5.52941 5.23077 5.78824 5.23077 6.11765V20.2353C5.23077 20.5647 5.50155 20.8235 5.84616 20.8235H18.1539C18.4985 20.8235 18.7693 20.5647 18.7693 20.2353V6.11765C18.7693 5.78824 18.4985 5.52941 18.1539 5.52941H15.6924V4.35294H18.1539C19.1632 4.35294 20.0001 5.12941 20.0001 6.11765V20.2353C20.0001 21.2 19.1632 21.9765 18.1539 22Z",
    fill: "#A614B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3076 6.70587H7.69216V7.88234H16.3076V6.70587Z",
    fill: "#A614B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08606 18.1882C7.74145 18.1882 7.47068 17.9294 7.47068 17.6C7.47068 17.5294 7.47067 17.4823 7.49523 17.4117L8.35686 14.894C8.38141 14.7999 8.43069 14.7292 8.50452 14.6586L13.723 9.69395C13.9692 9.48222 14.3384 9.48222 14.5846 9.69395L16.3324 11.3646C16.5787 11.6 16.5787 11.9763 16.3324 12.1882L11.1386 17.176C11.0647 17.2466 10.9909 17.2937 10.8923 17.3172L8.28314 18.1642C8.24633 18.1642 8.21553 18.1702 8.18472 18.1762C8.15387 18.1822 8.123 18.1882 8.08606 18.1882ZM9.48906 15.4117L9.04607 16.6587L10.3752 16.2353L15.0522 11.7647L14.166 10.9176L9.48906 15.4117Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEform);
export default __webpack_public_path__ + "static/media/eform.772acb12dcbfb3cb1f101b549db85e95.svg";
export { ForwardRef as ReactComponent };